import UniqueId from 'vue-unique-id';
import * as componentLibrary from './components';
import config from './config';

export default {
    install(Vue, options = {}) {
        if (this.install.installed) return;
        this.install.installed = true;

        Vue.use(UniqueId);

        const installComponents = options.components || null;
        delete options.components;

        const components = installComponents || componentLibrary;

        config.options = options;

        Object.keys(components).forEach((key) => {
            Vue.component(config.options.prefix + key, components[key]);
        });
    },
};
